import { useCallback } from 'react';
import axios, { AxiosResponse } from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import { serviceURLs } from './axios.constant';

interface IUseApiData {
  fetchData: <T>(
    url: string,
    baseService: string,
    params?: any
  ) => Promise<AxiosResponse<T>>;
}

const useGetApiData = (): IUseApiData => {
  const { getAccessTokenSilently } = useAuth0();

  const fetchData = useCallback(
    async <T,>(
      url: string,
      baseService: string,
      params?: any
    ): Promise<AxiosResponse<T>> => {
      const baseUrl = window.gbl_service_urls[serviceURLs[baseService]];
      const apiUrl = `${baseUrl}${url}`;
      const token = await getAccessTokenSilently();

      return axios.get<T>(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'tenantid': '00000000-0000-0000-0000-000000000000',
          Authorization: `Bearer ${token}`
        },
        params
      });
    },
    [getAccessTokenSilently]
  );

  return { fetchData };
};

export default useGetApiData;
